module.exports = __webpack_public_path__ + "img/wave_05.cb073d37.png";